import OrcamentoDetalhe from './OrcamentoDetalhe';

export default OrcamentoDetalhe;